<template>
  <div class="warpper">
    <el-steps :active="step" align-center>
      <el-step title="上传试题"></el-step>
      <el-step title="检查试题"></el-step>
      <el-step title="题库查重"></el-step>
      <el-step
        title="导入试题"
        :status="step > 2 ? 'finish' : 'wait'"
      ></el-step>
    </el-steps>
    <div style="margin-top: 40px" v-if="step == 0">
      <el-upload
        action="api/question/parse"
        :before-upload="beforeUploadTemplate"
        :headers="{ Authorization: getStore('accessToken'), accountId: 1 }"
        :on-success="questionParse"
        style="display: flex; justify-content: center"
      >
        <el-button type="primary" icon="el-icon-upload"
          >选择文件上传试题</el-button
        >
      </el-upload>
      <div class="tipsBar">
        <div
          class="actBox"
          v-for="(act, aidx) in actList"
          :key="'act' + aidx"
          @mouseout="act.ifHover = false"
          @mouseover="act.ifHover = true"
        >
          <div class="actIcon">
            <img v-if="act.ifHover" :src="act.hoverPic" alt />
            <img v-else :src="act.pic" alt />
          </div>
          <div class="actBtn" @click="downloadtemplate">{{ act.font }}</div>
        </div>
      </div>
    </div>

    <div class="questionTableContainer" v-if="step == 1">
      <div class="actBar">
        <el-button type="warning" @click="step--">返回上一步</el-button>
        <el-button type="primary" @click="step++">
          <i class="el-icon-right"></i>
          检查完毕，下一步
        </el-button>
      </div>
      <div class="tip">
        导入试题 {{ questionList.length }} 道，其中
        {{ questionList.filter((item) => !item.result).length }} 道解析失败(第{{
          canotParseQuestionIds
        }}题解析失败)，{{ questionListRepeat.length }}道重复
      </div>

      <div class="questionListContainer">
        <div
          class="questionBox"
          v-for="(item, idx) in questionParsed"
          :key="'question' + idx"
        >
          <div class="repeatTag" v-if="item.repeat">重复</div>
          <p class="questionTitle">
            {{ idx + 1 }}、
            <strong>{{ item.type }}</strong>
            {{ item.content }}
          </p>
          <div
            class="questionSelectionContainer"
            v-if="
              item.questionTypeId == 1 ||
              item.questionTypeId == 2 ||
              item.questionTypeId == 5
            "
          >
            <div
              class="questionSelection"
              v-for="(select, selidx) in item.answerDTOList"
              :key="'select' + selidx"
            >
              <img
                :src="chosenPic"
                v-if="select.isCorrect == 2"
                style="width: 18px; height: 18px"
                alt
              />
              <span
                v-else
                style="
                  width: 18px;
                  height: 18px;
                  border: 1px solid #000;
                  display: inline-block;
                "
              ></span>
              <span style="flex: 1; margin-left: 10px">{{
                select.content
              }}</span>
            </div>
          </div>
          <div class="answerBar">
            [答案]
            <span
              v-if="
                item.questionTypeId == 1 ||
                item.questionTypeId == 2 ||
                item.questionTypeId == 5
              "
              >{{ item.consultAnswer }}</span
            >
            <span v-else>
              <span
                v-for="(answer, anidx) in item.answerDTOList"
                :key="'consult' + anidx"
                >{{ answer.content }}&nbsp;&nbsp;</span
              >
            </span>
          </div>
          <div>
            <span style="color: #ccc">分数:</span>
            &nbsp;{{ item.score }}
          </div>
          <div>
            <span style="color: #ccc">分类:</span>
            &nbsp;{{ item.groupName }}
          </div>
          <div>
            <span style="color: #ccc">标签:</span>
            &nbsp;{{ item.labelShow }}
          </div>
          <div>
            <span style="color: #ccc">解析:</span>
            &nbsp;{{ item.analysis }}
          </div>
        </div>
      </div>
    </div>
    <div class="repeatContainer" v-if="step == 2">
      <div v-if="questionListRepeat.length == 0" style="text-align: center">
        <i
          class="el-icon-circle-check"
          style="
            color: #618afd;
            font-size: 60px;
            display: block;
            text-align: center;
          "
        ></i>
        共识别到{{ questionList.length }}道题，没有检查到重复试题，
        请点击右下角"立即导入"开始导入试题。
      </div>
      <div v-else>
        <div class="importTips">
          共{{ questionList.length }}道试题识别成功，其中有{{
            questionListRepeat.length
          }}道已存在与题库中；如果您想继续导入重复的试题，请勾选列表中的试题，确认要导入的题目后点击"选择导入X题"即可
        </div>
        <el-table
          ref="multipleTable"
          :data="questionListRepeat"
          tooltip-effect="dark"
          style="width: 100%"
          @select="questionSelect"
          @select-all="questionSelect"
        >
          <el-table-column
            type="selection"
            width="55"
            prop="choose"
          ></el-table-column>
          <el-table-column label width="120">
            <template slot-scope="scope">
              <span class="blueLabel">第{{ scope.$index + 1 }}题</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="type"
            label="题型"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="content"
            label="题目"
            show-overflow-tooltip
          ></el-table-column>
        </el-table>
      </div>

      <div class="actBar">
        <el-button type="warning" @click="step--">返回上一步</el-button>
        <el-button type="primary" @click="importPost">立即导入</el-button>
      </div>
    </div>
    <div v-if="step >= 3">
      <div style="text-align: center; margin: 100px 0">
        <i
          class="el-icon-circle-check"
          style="
            color: #618afd;
            font-size: 60px;
            display: block;
            text-align: center;
          "
        ></i>
        导入成功
        <span v-for="(item, key) in importResult" :key="key"
          >{{ key }}:{{ item }}题&nbsp;&nbsp;</span
        >
      </div>
      <div class="actBar">
        <el-button
          type="primary"
          @click="$router.push({ name: 'questionList' })"
          >查看试题列表</el-button
        >
        <el-button type="primary" @click="pageRefresh">继续导入试题</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { batchCreate, getQuestionBatchTemplate } from "@/api/question.js";
export default {
  data() {
    return {
      actList: [
        // {
        //   pic: require("@/assets/img/word1.png"),
        //   hoverPic: require("@/assets/img/word.png"),
        //   font: "下载Word文档模板",
        //   ifHover: false,
        // },
        {
          pic: require("@/assets/img/excel1.png"),
          hoverPic: require("@/assets/img/excel.png"),
          font: "下载Excel文档模板",
          ifHover: false,
        },
        // {
        //   pic: require("@/assets/img/movie1.png"),
        //   hoverPic: require("@/assets/img/movie.png"),
        //   font: "下载音视频上传工具",
        //   ifHover: false,
        // },
      ],
      step: 0,
      questionList: [],
      questionChosen: [],
      importResult: "",
      fileName: "",
      chosenPic: require("@/assets/img/check-square.png"),
    };
  },
  computed: {
    questionListRepeat() {
      return this.questionList.filter((item) => item.repeat && item.result);
    },
    questionParsed() {
      return this.questionList.filter((item) => item.result);
    },
    canotParseQuestionIds() {
      return this.questionList
        .reduce((total, cur, arr) => {
          if (!cur.result) {
            total.push(cur.idx + 2);
          }
          return total;
        }, [])
        .join(",");
    },
  },
  created() {},
  mounted() {},
  methods: {
    pageRefresh() {
      Object.assign(this.$data, this, this.$options.data());
    },
    questionParse(response, file, fileList) {
      this.step = 1;
      response.data.forEach((item, idx) => {
        item.choose = item.repeat ? false : true;
        item.idx = idx;
        item.labelShow = item.labelDTOList.reduce((total, cur, arr) => {
          return total + cur.labelName;
        }, "");
      });

      this.questionList = response.data;
    },
    downloadtemplate() {
      getQuestionBatchTemplate().then((data) => {
        window.open(data);
      });
    },
    beforeUploadTemplate(file) {
      this.fileName = file.name;
    },
    questionSelect(selectList, select) {
      if (select) {
        select.choose = !select.choose;
        console.log(select);
      } else {
        let repeatList = this.questionList.filter((item) => item.repeat);
        if (repeatList.every((item) => item.choose)) {
          repeatList.forEach((item) => (item.choose = false));
        } else {
          repeatList.forEach((item) => (item.choose = true));
        }
      }
      this.$forceUpdate();
      setTimeout(() => {
        console.log(this.questionList.map((item) => item.choose));
      }, 100);
    },
    importPost() {
      // console.log(this.questionList.filter((item) => item.choose));
      if (
        !this.questionList.filter((item) => item.choose && item.result).length
      ) {
        this.$message.warning("请至少勾选一道题");
        return;
      }

      batchCreate({
        fileName: this.fileName,
        reqList: this.questionList.filter((item) => item.choose && item.result),
      }).then(
        (data) => {
          console.log(data);
          this.importResult = data.typeNum;
          this.$message.success("导入成功");
          this.step += 2;
        },
        (err) => {
          console.log(err);
        }
      );
    },
  },
};
</script>

<style scoped lang="less">
.warpper {
  margin: 40px;
  background: #fff;
  padding: 30px;
  min-height: 600px;
  .tipsBar {
    margin: 90px 5% 10px 5%;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    .actBox:nth-child(1):hover {
      box-shadow: 0px 3px 10px 0px rgba(54, 170, 253, 0.3);
      .actIcon {
        box-shadow: 0px 3px 10px 0px rgba(54, 170, 253, 0.3);
      }
      .actBtn {
        background: rgba(54, 170, 253);
        color: #fff;
        cursor: pointer;
      }
    }
    .actBox:nth-child(2):hover {
      box-shadow: 0px 3px 10px 0px rgba(28, 175, 154, 0.3);
      .actIcon {
        box-shadow: 0px 3px 10px 0px rgba(28, 175, 154, 0.3);
      }
      .actBtn {
        background: rgba(28, 175, 154);
        color: #fff;
      }
    }
    .actBox:nth-child(3):hover {
      box-shadow: 0px 3px 10px 0px rgba(255, 150, 42, 0.3);
      .actIcon {
        box-shadow: 0px 3px 10px 0px rgba(255, 150, 42, 0.3);
      }
      .actBtn {
        background: rgba(255, 150, 42);
        color: #fff;
      }
    }
    .actBox {
      position: relative;
      text-align: center;
      width: 180px;
      height: 130px;
      background-color: #ffffff;
      box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.05);
      border-radius: 10px !important;
      .actIcon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 90px;
        height: 90px;
        background-color: #ffffff;
        box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.05);
        transform: translate(-50%, -50%);
        position: absolute;
        left: 50%;
        top: 0;
        border-radius: 50% !important;
      }
      .actBtn {
        background-color: #ffffff;
        box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.05);
        border-radius: 20px !important;
        line-height: 32px;
        border: 0;
        width: 80%;
        position: absolute;
        bottom: 15px;
        left: 50%;
        transform: translateX(-50%);
        font-size: 14px;
        color: #999999;
        cursor: pointer;
      }
    }
  }

  .actBar {
    display: flex;
    justify-content: center;
    width: 75%;
    margin: 20px auto;
  }

  .questionListContainer {
    .questionBox {
      width: 75%;
      margin: 20px auto;
      box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.3);
      padding: 20px;
      position: relative;
      .repeatTag {
        position: absolute;
        background: red;
        color: #fff;
        top: 0;
        right: 0;
        font-size: 13px;
        padding: 3px 6px;
      }
    }
    .questionSelectionContainer {
      .questionSelection {
        border: 1px solid #ccc;
        border-radius: 5px;
        display: flex;
        padding: 8px;
        margin: 10px 0;
      }
    }
  }
  .repeatContainer {
    .importTips {
      padding: 14px 24px;
      background-color: #dcf0ff;
      color: #36aafd;
      border-left: 4px solid #36aafd;
    }
  }
  .blueLabel {
    background: #618afd;
    padding: 8px;
    border-radius: 50%;
    color: #fff;
  }
}
.tip {
  padding: 8px 16px;
  background-color: #ecf8ff;
  border-radius: 4px;
  border-left: 5px solid #50bfff;
  margin: 20px auto;
  width: 75%;
}
</style>
